<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="90"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Bekræftelse</div>
            </div>
        </section>
        <section id="pay-section" class="mobile-container bg-light">
            <div class="py-2" v-if="additionalServicesProp['totalPrice']['value'] > 0">
                <div class="mb-4">
                    Din betaling er nu gået igennem!
                    Tak for tilliden 💘&nbsp;🚗
                </div>
                <div class="mb-4">
                    Vi har nu modtaget dine tilvalg, og ser frem til at håndbære dine ønsker til chaufføren.
                </div>
                <div class="mb-4">
                    Din ordrebekræftelse sendes på SMS.
                    Ønsker du ordrebekræftelsen sendt på mail?
                    <div class="d-flex mb-1">
                        <input type="text"
                               class="form-control"
                               v-model="email">
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="mb-4">
                    Tak for at bekræfte dine valg.
                    Og endnu engang tak for tilliden 💘&nbsp;🚗
                </div>
                <div class="mb-4">
                    PS - Ønsker du ordrebekræftelsen sendt på mail, udfyld din mail nedenfor.
                    <div class="d-flex mb-1">
                        <input type="text"
                               class="form-control"
                               v-model="email">
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-between flex-wrap">
                <button class="btn btn-primary mb-2" @click="openModalIframe">Hjælp</button>
                <button class="btn btn-primary mb-2" @click="goToTheStart">Foretag ændringer (kan kræve yderligere betaling)</button>
                <button class="btn btn-success" @click="goNext">Send ordrebekræftelse</button>
            </div>
        </section>

        <modal-iframe ref="modal-iframe" @toggleActiveIframeModalInterval="toggleActiveIframeModalInterval"></modal-iframe>
        <div v-if="activeIframeModalInterval" class="modal-backdrop fade show"></div>

    </div>

</template>

<script>
import FlashError from "./reusable/FlashError.vue";
import ProgressBar from "./reusable/ProgressBar.vue";
import ModalIframe from "./reusable/ModalIframe.vue";
export default {
    name: "CmfStep7",
    components: {ModalIframe, ProgressBar, FlashError},
    props: {
        booking: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        firstUrl: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        applyChangesUrl: {type: String, required: true},
    },
    data() {
        return {
            email: '',
            activeIframeModalInterval: false,
        }
    },
    methods: {
        goToTheStart() {
            window.location.href = this.firstUrl;
        },
        goNext() {
            if (this.email) {
                const sendEmail = !!this.email;
                axios.post(this.applyChangesUrl, {
                        sendEmail: {key: 'sendEmail', enabled: sendEmail, email: this.email},
                        finishProcess: true
                    })
                    .then((response) => {
                        this.flashMessage.success({
                            title: '',
                            message: 'Ordrebekræftelse sendt',
                            time: 4000,
                            blockClass: 'flash-message'
                        });


                    }).catch(error => {
                    this.$refs.flashError.flashError(error);
                });
            } else {
                this.flashMessage.error({
                    title: '',
                    message: 'Enter an email address',
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            }
        },
        openModalIframe() {
            this.$refs["modal-iframe"].toggleModal();
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },

    },
}

</script>

<style scoped>

</style>
